export default __webpack_public_path__ + "static/media/FP_FM.ccf72a7f.png";